import { render, staticRenderFns } from "./ShippingCompaniesEdit.vue?vue&type=template&id=3c97ee54&"
import script from "./ShippingCompaniesEdit.vue?vue&type=script&lang=ts&"
export * from "./ShippingCompaniesEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports